var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBellMuted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3121 7.71825C12.8222 6.37356 14.1483 5.38086 15.6703 5.38086C17.1913 5.38086 18.5181 6.37339 19.0284 7.71825C21.8415 9.00152 23.8047 11.8507 23.8047 15.1231V19.8242C25.0815 20.1124 26.0156 21.2394 26.0156 22.6105C26.0156 23.1691 25.8525 23.6854 25.5717 24.1189L24.4596 22.9846C24.4962 22.8656 24.5156 22.7399 24.5156 22.6105C24.5156 21.8445 23.9243 21.2527 23.1578 21.2527H22.7616L22.3047 20.7867V15.1231C22.3047 12.3584 20.5796 9.95296 18.1379 8.96785L17.7862 8.82596L17.692 8.45862C17.4643 7.57044 16.6177 6.88086 15.6703 6.88086C14.7221 6.88086 13.8762 7.57045 13.6486 8.45856L13.5544 8.82596L13.2027 8.96785C12.6294 9.19913 12.0956 9.50868 11.6144 9.8828L10.5588 8.80613C11.092 8.37322 11.6807 8.00629 12.3121 7.71825ZM20.7147 23.9183L22.1853 25.4183H19.5668C18.8609 26.8701 17.3738 27.8807 15.6704 27.8807C13.9669 27.8807 12.4799 26.87 11.774 25.4183H8.18302C6.61462 25.4183 5.3252 24.1811 5.3252 22.6105C5.3252 21.2382 6.2603 20.1123 7.53614 19.8242V15.1231C7.53614 13.7858 7.86378 12.5194 8.44319 11.4017L9.56249 12.5434C9.22363 13.3388 9.03614 14.2113 9.03614 15.1231V21.2527H8.18302C7.41707 21.2527 6.8252 21.844 6.8252 22.6105C6.8252 23.3202 7.41018 23.9183 8.18302 23.9183H12.8138L12.986 24.4284C13.3704 25.5668 14.4469 26.3807 15.6704 26.3807C16.8939 26.3807 17.9704 25.5669 18.3548 24.4284L18.527 23.9183H20.7147ZM7.53162 6.56953C7.14498 6.17517 6.51184 6.1689 6.11747 6.55554C5.7231 6.94218 5.71684 7.57531 6.10348 7.96968L24.9605 27.2034C25.3472 27.5978 25.9803 27.604 26.3747 27.2174C26.7691 26.8307 26.7753 26.1976 26.3887 25.8032L7.53162 6.56953Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBellMuted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell-muted.cf2b5475c2ce053527874abeceabee19.svg";